module.exports = __webpack_public_path__ + "img/AICM会员系统.aa2cefd0.png";